export const initialUploadContainer = {
  audio: null,
  image: null,
  title: '',
  description: '',
  tags: [],
  category: '',
  playlistId: '',
  privacyStatus: 'public',
  license: 'youtube',
  madeForKids: 'no',
  uploadDate: null,
  isScheduled: false,
  disableWatermark: 'no',
};